import React, { FC, useState } from "react";
import { Helmet } from "react-helmet-async";
import Pagination from "shared/Pagination/Pagination";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SectionSliderCollections from "components/SectionSliderLargeProduct";
import SectionPromo1 from "components/SectionPromo1";
import ProductCard from "components/ProductCard";
import TabFilters from "../TabFilters";
import { PRODUCTS } from "data/data";
import {
  Box,
  Breadcrumbs,
  Button,
  Chip,
  Container,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import AvatarImage from "../../images/avatars/toksy.jpg";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StarIcon from "@mui/icons-material/Star";
import AccordionInfo from "containers/ProductDetailPage/AccordionInfo";
import ReviewItem from "components/ReviewItem";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LoopIcon from "@mui/icons-material/Loop";
import CheckIcon from "@mui/icons-material/Check";

import detail1JPG from "images/products/detail1.jpg";
import detail2JPG from "images/products/detail2.jpg";
import detail3JPG from "images/products/detail3.jpg";
import { useIsMobile } from "hooks/useIsMobile";

export interface PageCollectionProps {
  className?: string;
}

const BreadcrumbData = [
  { name: "Home", link: "/" },
  { name: "Category", link: "/category" },
  { name: "Service Title", link: "/service" },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const InsideFitMember: FC<PageCollectionProps> = ({ className = "" }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prevIsExpanded) => !prevIsExpanded);
  };

  const LIST_IMAGES_DEMO = [detail2JPG, detail2JPG, detail3JPG];

  const { isMobile } = useIsMobile();

  const renderReviews = () => {
    return (
      <div id="reviews" className="scroll-mt-[150px]">
        {/* HEADING */}
        <h2 className="text-2xl font-semibold flex items-center">
          <StarIcon className="w-7 h-7 mb-0.5" />
          <span className="ml-1.5"> 4,87 · 142 Reviews</span>
        </h2>

        {/* comment */}
        <div className="mt-10">
          <div className="grid grid-cols-1 gap-y-11 gap-x-28">
            <ReviewItem />
            <ReviewItem
              data={{
                comment: `I love the charcoal heavyweight hoodie. Still looks new after plenty of washes. 
                  If you’re unsure which hoodie to pick.`,
                date: "December 22, 2021",
                name: "Stiven Hokinhs",
                starPoint: 5,
              }}
            />
            <ReviewItem
              data={{
                comment: `The quality and sizing mentioned were accurate and really happy with the purchase. Such a cozy and comfortable hoodie. 
                Now that it’s colder, my husband wears his all the time. I wear hoodies all the time. `,
                date: "August 15, 2022",
                name: "Gropishta keo",
                starPoint: 5,
              }}
            />
            <ReviewItem
              data={{
                comment: `Before buying this, I didn't really know how I would tell a "high quality" sweatshirt, but after opening, I was very impressed. 
                The material is super soft and comfortable and the sweatshirt also has a good weight to it.`,
                date: "December 12, 2022",
                name: "Dahon Stiven",
                starPoint: 5,
              }}
            />
          </div>

          <ButtonSecondary
            onClick={() => false}
            className="mt-10 border border-slate-300 dark:border-slate-700 "
          >
            Show me all 142 reviews
          </ButtonSecondary>
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-PageCollection ${className}`}
      data-nc-id="PageCollection"
    >
      <Helmet>
        <title>Find your Fit specialist</title>
      </Helmet>

      <Container className="mb-28">
        <div className="mt-12">
          <Breadcrumbs aria-label="breadcrumb">
            {BreadcrumbData.map((item, index) => (
              <Typography key={index} color="textPrimary">
                {item.name}
              </Typography>
            ))}
          </Breadcrumbs>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 py-8">
          <div className="col-span-2 pr-0 lg:pr-36">
               <div>
                <Typography variant="h4" className="mb-2">
                Tayla Curnow
                </Typography>
                <Typography variant="body1" className="mb-2">
                  <LocationOnIcon fontSize="small" /> Tbilisi, Georgia
                </Typography>
                <button className="mt-2 border border-neutral-300 text-sm px-3 py-1 rounded-md bg-white">
                  Contact Me
                </button>
              </div>
            <div className="flex">
              <div className=" mt-5">
                <img
                  src={LIST_IMAGES_DEMO[0]}
                  className="w-full rounded-2xl object-cover"
                  alt="product detail 1"
                />

                <div className="grid grid-cols-2 gap-3 mt-3 sm:gap-6 sm:mt-6 xl:gap-8 xl:mt-8">
                  {[LIST_IMAGES_DEMO[1], LIST_IMAGES_DEMO[2]].map(
                    (item, index) => {
                      return (
                        <div
                          key={index}
                          className="aspect-w-11 xl:aspect-w-10 2xl:aspect-w-11 aspect-h-16"
                        >
                          <img
                            src={item}
                            className="w-full rounded-2xl object-cover"
                            alt="product detail 1"
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              </div>
            </div>

          

            <div className="mt-8">
              <div className="mb-2 font-black">
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "800",
                  }}
                >
                  Short description of the services provided by the freelancer.
                </Typography>
              </div>

              <Typography variant="body1" className="mb-4 font-semibold">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Saepe
                deleniti rem itaque iste nihil asperiores sapiente tempora
                fugiat iusto libero vitae, debitis ipsa dolores in accusantium
                eius voluptates, repellat enim!
              </Typography>
            </div>

              {isMobile ?
             <div className="col-span-1 mt-10 lg:mt-5">
             <Paper
               variant="outlined"
               className="min-h-[500px] sticky top-[100px] overflow-y-auto"
             >
               <Box sx={{ width: "100%" }}>
                 <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                   <Tabs
                     value={value}
                     onChange={handleChange}
                     aria-label="basic tabs example"
                     sx={{ display: "flex" }}
                     TabIndicatorProps={{
                       style: {
                         backgroundColor: "#4BC165",
                       },
                     }}
                   >
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Basic"
                       {...a11yProps(0)}
                     />
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Standart"
                       {...a11yProps(1)}
                     />
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Premiums"
                       {...a11yProps(2)}
                     />
                   </Tabs>
                 </Box>
                 <CustomTabPanel value={value} index={0}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$25
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
                 <CustomTabPanel value={value} index={1}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$50
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
                 <CustomTabPanel value={value} index={2}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$100
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
               </Box>
             </Paper>
           </div>
          : null}

            <div className="flex flex-wrap mt-8">
              <Chip label="Frontend development" className="mx-1 mb-2" />
              <Chip label="Typescript" className="mx-1 mb-2" />
              <Chip label="React.js" className="mx-1 mb-2" />
              <Chip label="Next.js" className="mx-1 mb-2" />
              <Chip label="Tailwind css" className="mx-1 mb-2" />
              <Chip label="Node.js" className="mx-1 mb-2" />
              <Chip label="MongoDB" className="mx-1 mb-2" />
            </div>

            <div className="mt-8">
              <div className="mb-2 font-black">
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "800",
                  }}
                >
                  Languages
                </Typography>
              </div>

              <div className="flex flex-wrap mt-5">
                <Chip label="Georgian" className="mx-1 mb-2" />
                <Chip label="English" className="mx-1 mb-2" />
                <Chip label="Russian" className="mx-1 mb-2" />
              </div>
            </div>

            <div className="mt-8">
              <div className="mb-2 font-black">
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "500",
                    display: "inline-block",
                    marginRight: "6px",
                  }}
                >
                  About{" "}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "800",
                    display: "inline-block",
                  }}
                >
                  Tayla
                </Typography>
              </div>

              <Typography
                variant="body1"
                className={`mb-4 font-semibold ${
                  isExpanded ? "expanded" : "collapsed"
                }`}
              >
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Saepe
                deleniti rem itaque iste nihil asperiores sapiente tempora
                fugiat iusto libero vitae, debitis ipsa dolores in accusantium
                eius voluptates, repellat enim! Inventore quos eum incidunt
                nihil consequuntur error totam quae aliquid dolore beatae
                repellendus ratione quibusdam iure at provident, reprehenderit
                neque modi accusantium commodi rem autem! Aut officia alias
                obcaecati ad. Amet omnis atque unde minima eos debitis labore,
                laborum provident doloremque necessitatibus culpa ab suscipit
                nisi quasi odit nam voluptate ad illo nesciunt excepturi
                recusandae, repellendus placeat consequatur? Eaque, excepturi!
                Architecto esse aliquam sed eaque cumque, provident et alias
                expedita beatae velit assumenda dolorem quia similique, quod
                cum, odit unde! Quibusdam cumque necessitatibus dignissimos?
                Ipsa aut modi quia dolorem dolores!
              </Typography>

              <button
                onClick={toggleExpand}
                className="text-grey-600 underline cursor-pointer"
              >
                {isExpanded ? "Read less" : "Read more"}
              </button>
            </div>

            <div className="mt-8">
              <div className="mb-2 font-black">
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "800",
                    display: "inline-block",
                    marginRight: "6px",
                  }}
                >
                  FAQ
                </Typography>
              </div>

              <AccordionInfo />
              {/*  */}
              <div className="mt-12">{renderReviews()}</div>
            </div>
          </div>

          {!isMobile ?
             <div className="col-span-1 mt-20 lg:mt-0">
             <Paper
               variant="outlined"
               className="min-h-[500px] sticky top-[100px] overflow-y-auto"
             >
               <Box sx={{ width: "100%" }}>
                 <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                   <Tabs
                     value={value}
                     onChange={handleChange}
                     aria-label="basic tabs example"
                     sx={{ display: "flex" }}
                     TabIndicatorProps={{
                       style: {
                         backgroundColor: "#4BC165",
                       },
                     }}
                   >
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Basic"
                       {...a11yProps(0)}
                     />
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Standart"
                       {...a11yProps(1)}
                     />
                     <Tab
                       sx={{
                         flex: "1",
                         "&.Mui-selected": {
                           color: "#4BC165",
                         },
                       }}
                       label="Premiums"
                       {...a11yProps(2)}
                     />
                   </Tabs>
                 </Box>
                 <CustomTabPanel value={value} index={0}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$25
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
                 <CustomTabPanel value={value} index={1}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$50
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
                 <CustomTabPanel value={value} index={2}>
                   <Box>
                     <Typography
                       variant="h6"
                       sx={{
                         fontWeight: "800",
                       }}
                     >
                       US$100
                     </Typography>
 
                     <Box className="mt-6" />
 
                     <Typography variant="body2" className="mb-4 font-semibold">
                       <strong>Basic Zapier Zap (Fast delivery)</strong> 1
                       single-step/simple Zapier automation setup or bug fix with
                       hand-over document.
                     </Typography>
 
                     <Stack direction={"row"} className="mt-20">
                       <Stack direction={"row"} className="mr-4">
                         <AccessTimeIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           2 Days Delivery
                         </Typography>
                       </Stack>
 
                       <Stack direction={"row"}>
                         <LoopIcon fontSize="small" className="mr-1" />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold"
                         >
                           3 Revisions
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Stack className="mt-6">
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1 bold"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Source code
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Detailed code comments
                         </Typography>
                       </Stack>
                       <Stack direction={"row"} className="mr-4 mb-2">
                         <CheckIcon
                           fontSize="small"
                           className="mr-1"
                           sx={{
                             stroke: "black",
                             strokeWidth: 2,
                           }}
                         />
                         <Typography
                           variant="body2"
                           className="mb-4 font-semibold text-slate-500"
                         >
                           Database integration
                         </Typography>
                       </Stack>
                     </Stack>
 
                     <Box>
                       <ButtonPrimary className="w-full mt-6">
                         Continue
                       </ButtonPrimary>
                     </Box>
                   </Box>
                 </CustomTabPanel>
               </Box>
             </Paper>
           </div>
          : null}
         
        </div>
      </Container>
    </div>
  );
};

export default InsideFitMember;
